import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import Text from '../Text'
import Loading from '../Loading'
import Table from '../Table'

export const GET_MODELS = gql`
  {
    models {
      id
      name
      manufacturerName
      manufacturer {
        id
        name
      }
    }
  }
`

const columns = [
  {Header: 'Name', accessor: 'name'},
  {Header: 'Manufacturer Name', accessor: 'manufacturerName'},
  {Header: 'Manufacturer', accessor: 'manufacturer.name'}
]

const List = ({onRowClick, filterable}) =>
  <Query query={GET_MODELS} fetchPolicy='cache-and-network'>
    {({loading, error, data}) => {
      if (error) return <Text error>{error.message}</Text>

      return (
        <React.Fragment>
          {loading && <Loading />}
          <Table
            filterable={filterable}
            noDataText={!loading && 'No models found!'}
            loading={loading}
            data={data.models}
            columns={columns}
            onRowClick={onRowClick}
          />
        </React.Fragment>
      )
    }}
  </Query>

export default List


// WEBPACK FOOTER //
// ./src/components/Models/List.js